import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const nimble = defineConnector({
  identifier: "nimble",
  name: "Nimble",
  tagLine: "Real-time web search and data extraction",
  logo,
  protocol: "http",
  tags: ["ai", "data"],
  defaultUrlPattern: () => "https://sdk\\.nimbleway\\.com/v[12]/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Get your API key",
      items: [
        {
          kind: "markdown",
          content:
            "Copy your API key from [Nimble Settings → API Keys](https://online.nimbleway.com/settings/api-keys).",
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => ({
      url: "https://sdk.nimbleway.com/v2/search",
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        query: "test",
        max_results: 1,
        search_depth: "lite",
      }),
    }),
  },
});
